export enum ForWhomEnum {
    AllEmployee = 1,
    Supervisors = 2,
}
export const ForWhomMap: Record<number, string> = {
    [ForWhomEnum.AllEmployee]: 'All Employee',
    [ForWhomEnum.Supervisors]: 'Supervisors',
};
